export default {
  "APP_INVENTORY_VIEW": "MDM_IMP_INVENTORY_VIEW", 
  "IMPORT_APP_VIEW": "IMPORT_APP_VIEW",
  "APP_COMMERCE_VIEW": "COMMERCEUSER_VIEW",
  "APP_PRODUCT_IDENTIFIER_UPDATE":"COMMON_ADMIN",
  "APP_PWA_STANDALONE_ACCESS": "COMMON_ADMIN"
} as any 